import { GlValidationResponseType } from 'pages/AuthorizePaymentPage/interCompany/types';

export const glPostingFailedData: GlValidationResponseType = {
  errorList: [
    'GL1076 - Account 1113 is not set up for company 1. Use a different account or set up the account in Accounting Settings - Accounts.',
    'GL1114 -  Control GM14A164 for account 1112 is not in the vehicle inventory file. Use a different control or account, or add the vehicle to inventory.'
  ]
};

export const glPostingSuccessData: GlValidationResponseType = {
  errorList: []
};
